import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { deleteChat, getChat, getChatHistory } from 'api';
import { AxiosRequestConfig } from 'axios';

export const useChatHistoryQuery = (userId: string, config?: AxiosRequestConfig) => {
  const query = useQuery({
    queryKey: ['chatHistory'],
    queryFn: () => {
      return getChatHistory(userId, config);
    }
  });
  return query;
};

export const useChatQuery = (chatId: string | undefined, config?: AxiosRequestConfig) => {
  const query = useQuery({
    queryKey: ['chat', chatId],
    queryFn: () => {
      if (!chatId) return [];
      return getChat(chatId, config);
    },
    enabled: !!chatId
  });
  return query;
};

/**
 * A custom hook to chat with the AI-Chat Service.
 *
 * @returns UseMutationResult<unknown, Error>
 */
export const useChatMutation = (config?: AxiosRequestConfig) => {
  const queryClient = useQueryClient();

  const deletion = useMutation<unknown, Error, string>({
    mutationFn: args => {
      return deleteChat(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['chatHistory'] });
    }
  });

  return {
    deletion
  };
};
